import { FC, Dispatch, SetStateAction } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { WishlistForm } from './WishlistForm'
import {
    useCreateWishlist,
    WishlistInputVariable
} from '../Hooks/use-create-wishlist'
import { WishlistVisibilityEnum } from '@pylot-data/enums/WishlistVisibilityEnum.d'
import { ToastType, useUI } from '@corratech/pylot-ui/context'

export type Props = {
    show: boolean
    setShow: Dispatch<SetStateAction<boolean>>
    canRedirect?: boolean
    onCreate?: (id: number) => void
}

export const CreateWishlist: FC<Props> = ({
    show,
    setShow,
    canRedirect = true,
    onCreate
}) => {
    const { t } = useTranslation(['wishlist'])
    const router = useRouter()
    const { openToast } = useUI()
    const { createWishList, isLoading } = useCreateWishlist()

    const closeConfirm = () => {
        setShow(false)
    }

    const onSubmit = async (inputData: WishlistInputVariable) => {
        try {
            const response = await createWishList({
                ...inputData,
                visibility: inputData?.visibility
                    ? WishlistVisibilityEnum.Public
                    : WishlistVisibilityEnum.Private
            })

            if (response?.errors?.length) {
                openToast(response?.errors[0].message, ToastType.Danger)
            }

            if (response?.data?.createWishlist) {
                const { id, name } = response?.data?.createWishlist?.wishlist

                if (canRedirect) router.push(`/account/wishlist/${id}`)

                //callback on create wishlist
                if (onCreate) onCreate(Number(id))

                if (!onCreate) {
                    openToast(
                        t('wishlist|Wish list "{{ name }}" was saved.', {
                            name
                        }),
                        ToastType.Success
                    )
                }
            }
        } catch (e) {
            if (e) {
                openToast(
                    t('wishlist|Something went wrong. Please try again'),
                    ToastType.Danger
                )
            }
        }
        //close confirm box
        closeConfirm()
    }

    return (
        <WishlistForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            show={show}
            setShow={setShow}
        />
    )
}
